<template>
  <div class="paper-container"></div>
</template>

<script setup lang="ts">
import RappidContext from "./rappid/rappid-context";
import SelectionController from "./rappid/selection-controller";
import RappidController from "./rappid/rappid-controller";
import MouseWheelController from "./rappid/mousewheel-controller";
import MouseNavigationController from "./rappid/mouse-navigation-controller";
import ValidationController from "./rappid/validation-controller";
import KeyboardController from "./rappid/keyboard-controller";
import { Renderer } from "./services/renderer";
import { ValidatorService } from "./services/validation-service";
import { inject, onMounted } from "vue";
import { StatechartsService } from "./services/statecharts/statecharts-service";
import { PreferenceStore } from "./services/preference-store";

const rappidContext: RappidContext = inject<RappidContext>("rappidContext");

const validatorService: ValidatorService = inject<ValidatorService>("validatorService");

const cloudStatechartService: StatechartsService = inject<StatechartsService>("cloudStatechartService");

onMounted(() => {
  Renderer.renderView(".paper-container", rappidContext.paperScroller);

  // Validation Controller should be before others
  const validationController = new ValidationController(rappidContext, validatorService);
  validationController.activate();

  const selectionController = new SelectionController(rappidContext);
  selectionController.activate();

  const rappidController = new RappidController(rappidContext);
  rappidController.activate();
  const keyboardController = new KeyboardController(rappidContext);
  keyboardController.activate();

  const mouseController = new MouseWheelController(rappidContext);
  mouseController.activate();

  const mouseNavigationController = new MouseNavigationController(rappidContext);
  mouseNavigationController.activate();

  // keep at end to prevent view from not being centered? #829
  rappidContext.paperScroller.render().center();

  PreferenceStore.INSTANCE.on("change:isReadOnly", () => {
    if (PreferenceStore.INSTANCE.isReadOnly) {
      keyboardController.disable();
    } else {
      keyboardController.enable();
    }
  });
});
</script>
<style scoped>
.paper-container {
  position: absolute;
  height: 100%;
  overflow: hidden;
  top: 0px;
  left: 0px;
  right: 0px;
}
</style>
<style src="./ace.css"></style>
<style src="./joint.css"></style>
<style src="./light.css"></style>
<style src="./dark.css"></style>
<style src="@clientio/rappid/joint-plus.css"></style>
